/* istanbul ignore file */
import { useState, useEffect } from 'react'
import { windowSizes } from '../../constants'

export default () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < windowSizes.MEDIUM_WIDTH)
    }

    // initial check
    checkIsMobile()

    // check for resizes
    window.addEventListener('resize', checkIsMobile)
    return () => {
      window.removeEventListener('resize', checkIsMobile)
    }
  }, [])

  return isMobile
}
